import React from "react";
import { useParams } from "react-router-dom";
import { PositionDetailTabs } from "./PositionDetailTabs";
import { PositionDetailRoutes } from "../Routes";
import { PositionDetailHeader } from "./PositionDetailHeader";

export const PositionDetailLayout = () => {
  const { position_id } = useParams();
  return (
    <div>
      <PositionDetailHeader position_id={position_id} />
      <PositionDetailTabs />
      <PositionDetailRoutes position_id={position_id} />
    </div>
  );
};
